<template>
  <div class="h-[44px] md:h-[90px] mx-4 md:mx-11 my-10 md:my-6 px-2 md:px-7 py-1 md:py-2 flex flex-row justify-between items-center">
    <div>
      <RouterLink :to="{ name: 'home' }">
        <Logo class="h-5 md:h-[52px]" />
      </RouterLink>
    </div>
    <div class="hidden md:flex flex-row px-2.5 py-2 bg-neutral-100 rounded-full gap-10 items-center">
      <VaPopover
        v-for="(item, index) in menuItems" :key="index"
        teleport="#header-popover"
        color="neutral-100"
        text-color="black"
        :disabled="!item.children?.length"
        :hoverOutTimeout="500"
        :offset="[20, -28]"
        placement="bottom-start"
        :keyboard-navigation="false"
      >
        <RouterLink
          class="px-4 py-2.5 text-black"
          :to="item.route"
        >
          <span class="text-lg">{{ t(item.textKey) }}</span>
        </RouterLink>

        <template #body>
          <div class="flex flex-col px-2.5 py-2 bg-neutral-100 text-left">
            <RouterLink
              v-for="(child, childIndex) in item.children" :key="childIndex"
              class="px-4 py-2.5 text-black"
              :to="child.route"
            >
              <span class="text-lg">{{ t(child.textKey) }}</span>
            </RouterLink>
          </div>
        </template>
      </VaPopover>
    </div>
    <div class="hidden md:block">
      <VaButton preset="secondary" border-color="red-600" round class="h-[60px]" :to="{ name: 'contact' }">
        <span class="text-xl font-medium">{{ t('header.contact') }}</span>
      </VaButton>
    </div>
    <div class="md:hidden">
      <VaButton color="white" round class="w-[44px] h-[44px]" @click="showSidebar">
        <MenuIcon class="h-[22px]" />
      </VaButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { VaButton, VaPopover } from 'vuestic-ui'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import Logo from '@/assets/images/logo.svg'
import MenuIcon from '@/assets/icons/menu.svg'
import { EventBus } from '@/services/event-bus'

const { t } = useI18n()
const menuItems = [
  {
    route: { name: 'products' },
    textKey: 'menu.products',
    children: [
      {
        route: { name: 'products', params: { product: 'starter' } },
        textKey: 'menu.productsStarter',
      },
      {
        route: { name: 'products', params: { product: 'pro' } },
        textKey: 'menu.productsPro',
      },
    ],
  },
  {
    route: { name: 'solutions' },
    textKey: 'menu.solutions',
    children: [
      {
        route: { name: 'solutions', params: { industry: 'retail' } },
        textKey: 'menu.solutionsRetail',
      },
      {
        route: { name: 'solutions', params: { industry: 'gastronomy' } },
        textKey: 'menu.solutionsGastronomy',
      },
      {
        route: { name: 'solutions', params: { industry: 'services' } },
        textKey: 'menu.solutionsServices',
      },
    ],
  },
  {
    route: { name: 'pricing' },
    textKey: 'menu.pricing',
  },
  {
    route: { name: 'resources' },
    textKey: 'menu.resources',
  },
]

const showSidebar = () => {
  EventBus.dispatch('showSidebar')
}
</script>
